import Repository from "./Repository";

const CREATE_SHAREWORK = "sharework/create";
const GET_SHAREWORK = "sharework/get";
const UPDATE_SHAREWORK = "sharework/update";
const DELETE_SHAREWORK = "sharework/delete";
const SETLIKE_SHAREWORK = "sharework/setLike";

const EMAIL_CONTACTUS = "email/emailContactUs";

export default {
  createSharework(payload) {
    return Repository.post(transformRoute(CREATE_SHAREWORK), payload);
  },
  getSharework(payload) {
    return Repository.post(transformRoute(GET_SHAREWORK), payload);
  },
  updateSharework(payload) {
    return Repository.post(transformRoute(UPDATE_SHAREWORK), payload);
  },
  deleteSharework(payload) {
    return Repository.post(transformRoute(DELETE_SHAREWORK), payload);
  },
  setLike(payload) {
    return Repository.post(transformRoute(SETLIKE_SHAREWORK), payload);
  },

  emailContactUs(payload) {
    return Repository.post(transformRoute(EMAIL_CONTACTUS), payload);
  },

  //   emailBecomeVolunteer(payload) {
  //     return Repository.post(transformRouteemail(EMAIL_BECOME_VOL), payload);
  //   },
};

const transformRoute = (route) => {
  return `/hoc/${route}`;
};
// const transformRouteemail = (route) => {
//   return `/hoc/email/${route}`;
// };
